<template>
  <div>
    <div class="create-payment-section">
      <editable-input
        id="nameOnCard"
        ref="nameOnCard"
        v-model="name"
        :incorrect-value-msg="$t('fieldCannotBeEmpty')"
        reference="nameOnCard"
        lazy-validation
        :disabled="deactivateFields"
        :title="$t('nameOnCard')"
      />
      <div class="stripe-card-with-error card-number">
        <div class="stripe-card-element" :class="{ focused: focusedNum }">
          <span class="field-title">{{ $t('cardNumber') }}</span>
          <label :class="{ focused: focusedNum, incorrect: incorrectNumber, deactivated: deactivateFields }">
            <div class="brand-cardnumber-positioning">
              <span class="brand">
                <transition name="slide">
                  <img
                    :key="'@/assets/_desktop/_payments/icons/cc/' + cardBrand.toLowerCase() + '.svg'"
                    :src="require('@/assets/_desktop/_payments/icons/cc/' + cardBrand.toLowerCase() + '.svg')"
                  />
                </transition>
              </span>
              <div id="cardNumber" ref="cardNumber" />
            </div>
          </label>
        </div>
        <div id="card-number-error" class="card-error" />
      </div>
      <div class="stripe-card-with-error  card-expiry">
        <div class="stripe-card-element" :class="{ focused: focusedExp }">
          <span class="field-title">{{ $t('cardExpiry') }}</span>
          <label :class="{ focused: focusedExp, incorrect: incorrectExpiry, deactivated: deactivateFields }">
            <div id="cardExpiry" ref="cardExpiry" />
          </label>
        </div>
        <div id="card-expiration-error" class="card-error" />
      </div>
      <div class="stripe-card-with-error  card-cvc">
        <div class="stripe-card-element" :class="{ focused: focusedCvv }">
          <span class="field-title"
            >{{ $t('cardCvc') }}
            <div class="cvv-question-mark">
              ?
              <div class="cvv-message-explanation">{{ $t('cvvExplanationMessage') }}</div>
            </div></span
          >
          <label :class="{ focused: focusedCvv, incorrect: incorrectCvv, deactivated: deactivateFields }">
            <div id="cardCvc" ref="cardCvc" />
          </label>
        </div>
        <div id="card-cvv-error" class="card-error" />
      </div>
      <div class="button-row">
        <button class="clavo-button primary" :class="{ 'clavo-button-inactive': deactivateFields }" :disabled="deactivateFields" @click="createPaymentId">
          {{ $t('save') }}
        </button>
        <button class="clavo-button secondary" :class="{ 'clavo-button-inactive': deactivateFields }" :disabled="deactivateFields" @click="$emit('close')">
          {{ $t('cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EditableInput from '@/components/UI/EditableInput'
import ParseFunctions from '@/components/ParseFunctions'
import EventBus from '@/EventBus'
import BillingUtils from '@/components/Billing/BillingUtils'
import Constants from '@/components/Constants'

export default {
  name: 'CardPaymentSectionStripe',
  components: {
    EditableInput,
  },
  mixins: [ParseFunctions, BillingUtils, Constants],
  props: {
    teamId: String,
  },
  data() {
    return {
      focusedNum: false,
      focusedExp: false,
      focusedCvv: false,
      stripe: undefined,
      elements: undefined,
      cardNumber: undefined,
      cardExpiry: undefined,
      cardCvc: undefined,
      expiryDate: undefined,
      cardBrand: 'unknown',
      incorrectNumber: false,
      incorrectExpiry: false,
      incorrectCvv: false,
      paymentMethod: null,
      name: null,
      deactivateFields: false,
    }
  },
  mounted() {
    try {
      this.mountStripeScript()
      let style = {
        base: {
          color: '#081014',
          iconColor: '#081014',
          fontFamily: '"averta-regular",  sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '14px',
          letterSpacing: '0.2px',
          '::placeholder': {
            color: '#9093C0',
          },
          ':disabled': {
            color: '#9093C0',
          },
        },
        invalid: {
          color: 'black',
          iconColor: 'black',
        },
      }
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
      this.elements = this.stripe.elements()

      let cardNum = (this.cardNumber = this.elements.create('cardNumber', { style: style }))
      this.cardNumber.mount('#cardNumber')

      let cardExp = (this.cardExpiry = this.elements.create('cardExpiry', { style: style }))
      this.cardExpiry.mount('#cardExpiry')

      let cardCvv = (this.cardCvc = this.elements.create('cardCvc', { style: style }))
      this.cardCvc.mount('#cardCvc')

      cardExp.on(
        'change',
        function(event) {
          let displayError = document.getElementById('card-expiration-error')
          if (event.error) {
            this.incorrectExpiry = true
            this.focusedExp = false
            displayError.textContent = event.error.message
          } else {
            displayError.textContent = ''
            if (event.complete) {
              this.cardCvc.focus()
              this.focusedExp = false
              this.incorrectExpiry = false
            } else {
              this.focusedExp = true
              this.incorrectExpiry = false
            }
          }
        }.bind(this),
      )

      cardCvv.on(
        'change',
        function(event) {
          let displayError = document.getElementById('card-cvv-error')
          if (event.error) {
            this.incorrectCvv = true
            this.focusedCvv = false
            displayError.textContent = event.error.message
          } else {
            this.incorrectCvv = false
            this.focusedCvv = true
            displayError.textContent = ''
          }
        }.bind(this),
      )

      cardNum.on(
        'focus',
        function(event) {
          this.focusedNum = true
        }.bind(this),
      )
      cardNum.on(
        'blur',
        function(event) {
          this.focusedNum = false
        }.bind(this),
      )

      cardExp.on(
        'focus',
        function(event) {
          this.focusedExp = true
        }.bind(this),
      )
      cardExp.on(
        'blur',
        function(event) {
          this.focusedExp = false
        }.bind(this),
      )

      cardCvv.on(
        'focus',
        function(event) {
          this.focusedCvv = true
        }.bind(this),
      )
      cardCvv.on(
        'blur',
        function(event) {
          this.focusedCvv = false
        }.bind(this),
      )

      // function setOutcome(result) {
      //   let successElement = document.querySelector('.success');
      //   let errorElement = document.querySelector('.card-number-error');
      //   successElement.classList.remove('visible');
      //   errorElement.classList.remove('visible');
      //
      //   if (result.token) {
      //     // In this example, we're simply displaying the token
      //     successElement.querySelector('.token').textContent = result.token.id;
      //     successElement.classList.add('visible');
      //
      //     // In a real integration, you'd submit the form with the token to your backend server
      //     //var form = document.querySelector('form');
      //     //form.querySelector('input[name="token"]').setAttribute('value', result.token.id);
      //     //form.submit();
      //   } else if (result.error) {
      //     errorElement.textContent = result.error.message;
      //     errorElement.classList.add('visible');
      //   }
      // }

      let cardBrandToPfClass = {
        visa: 'pf-visa',
        mastercard: 'pf-mastercard',
        amex: 'pf-american-express',
        discover: 'pf-discover',
        diners: 'pf-diners',
        jcb: 'pf-jcb',
        unknown: 'pf-credit-card',
      }

      function setBrandIcon(brand) {
        let brandIconElement = document.getElementById('brand-icon')
        let pfClass = 'pf-credit-card'
        if (brand in cardBrandToPfClass) {
          pfClass = cardBrandToPfClass[brand]
        }
        for (let i = brandIconElement.classList.length - 1; i >= 0; i--) {
          brandIconElement.classList.remove(brandIconElement.classList[i])
        }
        brandIconElement.classList.add('pf')
        brandIconElement.classList.add(pfClass)
      }
      cardNum.on(
        'change',
        function(event) {
          // console.log(event.brand)
          if (['amex', 'discover', 'jcb', 'mastercard', 'unknown', 'visa'].includes(event.brand)) {
            this.cardBrand = event.brand
          } else {
            this.cardBrand = 'unknown'
          }
          let displayError = document.getElementById('card-number-error')
          if (event.error) {
            this.incorrectNumber = true
            this.focusedNum = false
            displayError.textContent = event.error.message
          } else {
            displayError.textContent = ''
            this.incorrectNumber = false
            if (event.complete) {
              this.cardExpiry.focus()
              this.focusedNum = false
            } else {
              this.focusedNum = true
            }
          }
        }.bind(this),
      )
    } catch (e) {
      console.error('mounting stripe elements error', e)
    }
  },
  methods: {
    async createPaymentId() {
      this.deactivateFields = true
      let condition = this.$refs.nameOnCard.validate()
      this.cardNumber.update({ disabled: true })
      this.cardExpiry.update({ disabled: true })
      this.cardCvc.update({ disabled: true })
      this.$store.commit('setShowProgressBar', true)
      this.stripe
        .createPaymentMethod({ type: 'card', card: this.cardNumber, billing_details: { name: this.name } })
        .then(
          async function(result) {
            // console.log(condition, result)
            if (result.paymentMethod && condition) {
              // console.log('result', result.paymentMethod)
              // console.log(this.teamId, result.paymentMethod.id)
              let res = await this.changeCardNumberPaymentId(this.teamId, result.paymentMethod.id)
              if (res.status === 'ok') {
                EventBus.$emit('new-info-bar-msg', {
                  msg: this.$t('paymentMethodUpdatedSuccess'),
                })
                this.$emit('save', result.paymentMethod)
              } else {
                EventBus.$emit('new-info-bar-msg', {
                  msg: this.$t('stripe.' + res.error.code),
                  error: true,
                })
              }
              this.deactivateFields = false
              this.cardNumber.update({ disabled: false })
              this.cardExpiry.update({ disabled: false })
              this.cardCvc.update({ disabled: false })
              EventBus.$emit('reload-teams')
            } else {
              if (condition) {
                this.cardNumber.update({ disabled: false })
                this.cardExpiry.update({ disabled: false })
                this.cardCvc.update({ disabled: false })
                EventBus.$emit('new-info-bar-msg', {
                  msg: this.$t(result.error.message),
                  error: true,
                })
              }
            }
            this.$store.commit('setShowProgressBar', false)
          }.bind(this),
        )
        .catch(e => {
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('stripePaymentMethodCreateError'),
            error: true,
          })
          this.$store.commit('setShowProgressBar', false)
          this.cardNumber.update({ disabled: false })
          this.cardExpiry.update({ disabled: false })
          this.cardCvc.update({ disabled: false })
          this.deactivateFields = false
        })
    },
  },
}
</script>

<style scoped lang="scss">
.create-payment-section {
  display: grid;
  grid-template-columns: 240px 240px;
  grid-column-gap: 20px;
  grid-row-gap: 24px;
  grid-template-areas:
    'nameOnCard nameOnCard'
    'cardNumber cardNumber'
    'cardExpiry cardCvc'
    'button-row button-row';
  //width: 460px;

  @include respond-below(xs) {
    display: flex;
    flex-direction: column;
    grid-row-gap: 0px; // shouldn't be applied when flex but it is on desktop
    > div {
      margin-bottom: 24px;
    }
  }

  #nameOnCard {
    grid-area: nameOnCard;
  }
  .button-row {
    display: flex;
    flex-wrap: wrap;

    grid-area: button-row;

    .clavo-button {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
      @include respond-below(xs) {
        flex: 1;
        min-width: 0px;
      }
    }
  }
  .stripe-card-with-error {
    .card-error {
      @include font-rule('averta-regular');
      font-size: 13px;
      color: $red;
      margin-top: 6px;
      letter-spacing: 0.33px;
      line-height: 18px;
    }

    &.card-number {
      grid-area: cardNumber;
    }

    &.card-expiry {
      grid-area: cardExpiry;
    }

    &.card-cvc {
      grid-area: cardCvc;
    }

    .stripe-card-element {
      @include animate-border-default(2px, 0);
      @include font-rule('averta-regular');

      &.focused {
        &:not(.incorrect) {
          @include animate-border-focused();
        }
      }

      .incorrect {
        border: 1px solid $red;
      }
      .deactivated {
        background-color: $white-lilac;
      }

      .field-title {
        @include font-rule('averta-semibold');
        font-size: 12px;
        line-height: 15px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        margin-right: 3px;
        margin-bottom: 5px;
        .cvv-question-mark {
          position: relative;
          display: inline-block;
          .cvv-message-explanation {
            visibility: hidden;
            width: 282px;
            background-color: white;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
            text-transform: none;

            //position of the tooltip
            position: absolute;
            bottom: 100%;
            left: 50%;
          }
        }

        .cvv-question-mark:hover .cvv-message-explanation {
          visibility: visible;
        }
      }

      position: relative;
      display: flex;
      flex-direction: column;

      .brand-cardnumber-positioning {
        display: grid;
        grid-template-columns: 30px auto;
        grid-template-rows: 24px;
        grid-template-areas: 'cardBrand cardNumber';

        #cardNumber {
          grid-area: cardNumber;
          align-self: center;
        }
        .brand {
          grid-area: cardBrand;
        }
      }
      label {
        font-size: 14px;
        padding: 10px;
        width: 100%;
        color: $black;
        border: 1px solid $flax-bloom;
        background-color: #ffffff;
        transition: border-color 0.2s;

        &.focused {
          border-color: $blue;
        }
      }
    }
  }
}
</style>
